import React, { createContext, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom'; // Import BrowserRouter
import { ToastContainer } from 'react-toastify';
import useWebSocket from './Api/useWebsocket';
import './App.css';
import './assets/css/style.css';
import Banner from './component/banner/banner';
import CreateBenefit from './component/benefit/addBenefit';
import BenefitManagement from './component/benefit/benifitManagement';
import CreateFaq from './component/FAQ/createFaq';
import FaqManagement from './component/FAQ/faqManagement';
import Layout from './component/Layout/Layout';
import Login from './component/Login/index';
import CreateMachine from './component/MachineManagement/CreateMachine';
import MachineManagement from './component/MachineManagement/MachineManagement';
import OrderManagement from './component/OrderManagement/OrderManagement';
import OrderReport from './component/OrderReport';
import ViewReport from './component/OrderReport/ViewReport';
import PagesTab from './component/pages/pagesTab';
import PaymentManagement from './component/PaymentManagement/PaymentManagement';
import ProfileUpdate from './component/Profile';
import ChangePassword from './component/Profile/ChangePassword';
import RecipientLogin from './component/RecipientLogin';
import RecipientForgetPassword from './component/RecipientLogin/Forget';
import RecipientManagement from './component/RecipientManagement';
import AddRecipient from './component/RecipientManagement/AddRecipient';
import RefundManagement from './component/refund/refundManagement';
import DeleteAccount from './component/static/delete';
import PrivacyPolicy from './component/static/privacy';
import ReportTransactionList from './component/Transaction/report_transaction';
import Transaction from './component/Transaction/Transaction';
import UserManagement from './component/UserInformation/UserManagement';
export const WebSocketContext = createContext();

function App() {
  const [GetWEBSocket, setWebSocket] = useState("");
  const { accessToken,selfInfo} = useSelector((state) => state.adminReducers);
    const admin = selfInfo?.user_type==="super_admin"
    const recipient = selfInfo?.user_type==="recipient"


  useWebSocket(`${process.env.REACT_APP_SERVICE_URL}${localStorage.getItem("access_token")}/`, setWebSocket, localStorage.getItem("access_token"));
   const LoginRoute = () => {
    return (
      <React.Fragment>
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/login" element={<Login />} />
      <Route path="/recipient-login" element={<RecipientLogin />} />
      <Route path="/forgot-password" element={<RecipientForgetPassword />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
      </React.Fragment>
    )
  }
  const SuperAdmin = () =>{
    return(
     <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/login" element={<Login />} />
        <Route path="/recipient-login" element={<RecipientLogin />} />
        <Route path="/login" element={accessToken === "" ? <Login /> : <Navigate  replace to={'/user-management'}/>} >
               <Route path="/login" element={accessToken === "" ? <Login /> : <Navigate  replace to={'/user-management'}/>} />
      </Route>
        <Route path="/user-management" element={accessToken !== "" ?<Layout><UserManagement RouteName="/user-management" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/recipient-management" element={accessToken !== "" ?<Layout><RecipientManagement RouteName="/recipient-management" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/add-recipient" element={accessToken !== "" ?<Layout><AddRecipient RouteName="/add-recipient" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/edit-recipient/:id" element={accessToken !== "" ?<Layout><AddRecipient RouteName="/edit-recipient" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/order-management" element={accessToken !== "" ?<Layout><OrderManagement RouteName="/order-management" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/order-report" element={accessToken !== "" ?<Layout><OrderReport RouteName="/order-report" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/view-report/:id" element={accessToken !== "" ?<Layout><ViewReport RouteName="/view-report" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/machine-management" element={accessToken !== "" ?<Layout><MachineManagement RouteName="/machine-management" /></Layout>:<Navigate replace to ="login"/>}/>
        <Route path="/add-machine" element={accessToken !== "" ?<Layout><CreateMachine RouteName="/add-machine" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/payment-management" element={accessToken !== "" ?<Layout><PaymentManagement RouteName="/payment-management" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/transaction-management" element={accessToken !== "" ?<Layout><Transaction RouteName="/transaction-management" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/edit-machine/:id" element={accessToken !== "" ?<Layout><CreateMachine RouteName="/add-machine" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/add-faq" element={accessToken !== "" ?<Layout><CreateFaq RouteName="/add-faq" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/edit-faq/:id" element={accessToken !== "" ?<Layout><CreateFaq RouteName="/add-faq" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/benefit" element={accessToken !== "" ?<Layout><BenefitManagement RouteName="/benefit" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/add-benefit" element={accessToken !== "" ?<Layout><CreateBenefit RouteName="/add-benefit" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/edit-benefit/:id" element={accessToken !== "" ?<Layout><CreateBenefit RouteName="/add-benefit" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/faq" element={accessToken !== "" ?<Layout><FaqManagement RouteName="/faq" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/banner" element={accessToken !== "" ?<Layout><Banner RouteName="/banner" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/page" element={accessToken !== "" ?<Layout><PagesTab RouteName="/page" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/refund" element={accessToken !== "" ?<Layout><RefundManagement RouteName="/refund" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/report-an-history" element={accessToken !== "" ?<Layout><ReportTransactionList RouteName="/report-an-history" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    )
  }
  const RecipientUser =()=>{
    return(
    <Routes>
        <Route path="/order-report" element={accessToken !== "" ?<Layout><OrderReport RouteName="/order-report" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/change-passowrd" element={accessToken !== "" ?<Layout><ChangePassword RouteName="/change-passowrd" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/view-report/:id" element={accessToken !== "" ?<Layout><ViewReport RouteName="/view-report" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="/profile" element={accessToken !== "" ?<Layout><ProfileUpdate RouteName="/profile" /></Layout>:<Navigate replace to ="recipient-login"/>} />
        <Route path="/recipient-login" element={<RecipientLogin />} />
        <Route path="/order-management" element={accessToken !== "" ?<Layout><OrderManagement RouteName="/order-management" /></Layout>:<Navigate replace to ="login"/>} />
        <Route path="*" element={<Navigate to="/order-management" />} />
    </Routes>     
    )
  }
  return (<WebSocketContext.Provider value={{ websocket: GetWEBSocket }}>
    <div className="App height_with_floats">
      {accessToken === "" ? LoginRoute() : admin  ? SuperAdmin()    : recipient  ? RecipientUser(): <Navigate to="/login" />}
      <ToastContainer />
    </div>
  </WebSocketContext.Provider>
  );
}

export default App;
